import { render, staticRenderFns } from "./PageLetsMakeASelfie.vue?vue&type=template&id=13472e12"
import script from "./PageLetsMakeASelfie.vue?vue&type=script&lang=js"
export * from "./PageLetsMakeASelfie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports